import * as type from "../types";

export function getTranscriptsData(payload) {
  return {
    type: type.GET_TRANSCRIPTS_DATA,
    payload: payload,
  };
}

export function putEditedTranscriptsData(payload) {
  return {
    type: type.PUT_EDIT_TRANSCRIPTS_DATA,
    payload: payload,
  };
}

